import React, { Component } from 'react';
import JobsDashboard from './Commons/JobsDashboard.js';

export default class PutawayDashboard extends Component {
	render() {
		return (
			<div>
				<JobsDashboard operationName={'Putaway'} operationType={'INWARDING'} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/PutawayDashboard.js